export default "__VITE_ASSET__FgbnK1RN__"